import React from 'react';
import { cn } from '../../lib/cn';

export function Card({ className, children, ...props }) {
  return (
    <div
      className={cn('bg-surface border border-line rounded-r3 shadow-card', className)}
      {...props}
    >
      {children}
    </div>
  );
}

export default Card;
